import NAME from "./constants";

export const getIsLoading = store => store[NAME].loading;
export const getGalleryImages = store => store[NAME].images;
